// ============================================
// PAGE - Clientes
// ============================================

export const ClientesPage = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900">Clientes</h1>
      <p className="text-gray-600 mt-2">Gestión de clientes (implementación similar a productos)</p>
      <div className="mt-6 rounded-lg border-2 border-dashed border-gray-300 p-12 text-center">
        <p className="text-gray-500">Módulo de clientes - Por implementar</p>
      </div>
    </div>
  );
};
